/**
 * 메뉴디자이너 랜딩(빈 상태) 화면.
 * 명령 입력은 헤더의 SNotes AI Bot(챗봇)으로 받으므로, 이 화면은
 * "어떤 화면을 그려드릴까요?"를 안내하는 empty-state 디자인만 표시한다.
 */
import React from "react";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import { C } from "@shared/libs/designTokens";

export default function LandingView() {
  return (
    <div
      className="snd-scroll"
      style={{ height: "100%", overflowY: "auto", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}
    >
      <div className="snd-fade-up" style={{ width: "100%", maxWidth: 460, textAlign: "center" }}>
        {/* 화면 와이어프레임 일러스트 (그려질 화면을 상징) */}
        <ScreenWireframe />

        <h1 style={{ fontSize: 18, fontWeight: 700, color: C.text, margin: "22px 0 8px", letterSpacing: -0.2 }}>
          어떤 화면을 그려드릴까요?
        </h1>
        <p style={{ fontSize: 12.5, color: C.greyText, margin: "0 0 20px", lineHeight: 1.7 }}>
          우측 상단 <SmartToyOutlinedIcon sx={{ fontSize: 14, verticalAlign: "-2px", color: C.text }} />{" "}
          <b style={{ color: C.text }}>SNotes AI Bot</b>에게 만들고 싶은 화면을 말씀해 주세요.
          <br />
          예: &ldquo;발주현황을 참고해서 발주현황_v2 화면을 만들어줘&rdquo;
          <br />
          화면이 마음에 들면 &ldquo;저장해줘&rdquo; → &ldquo;배포 확정&rdquo; 순으로 말씀하시면 배포됩니다.
        </p>
      </div>
    </div>
  );
}

/** 그려질 ERP 화면을 상징하는 점선 와이어프레임 (툴바 + 검색 + 그리드) */
function ScreenWireframe() {
  return (
    <div
      style={{
        position: "relative",
        width: 300,
        height: 190,
        margin: "0 auto",
        background: "linear-gradient(180deg, #ffffff, #fbfbfd)",
        border: `1.5px dashed ${C.blueBorder}`,
        borderRadius: 14,
        padding: 12,
        boxShadow: "0 8px 24px rgba(20,22,40,0.05)",
      }}
    >
      {/* 툴바 */}
      <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 10 }}>
        <Bar w={10} h={10} r={5} c={C.blueSoft2} />
        <Bar w={54} h={9} />
        <div style={{ flex: 1 }} />
        <Bar w={26} h={12} r={6} c={C.blueSoft2} />
        <Bar w={26} h={12} r={6} c={C.blue} />
      </div>

      {/* 검색조건 */}
      <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
        <Bar w={64} h={13} r={4} />
        <Bar w={64} h={13} r={4} />
        <Bar w={48} h={13} r={4} />
        <div style={{ flex: 1 }} />
        <Bar w={30} h={13} r={4} c={C.blueSoft2} />
      </div>

      {/* 그리드 헤더 */}
      <div style={{ display: "flex", gap: 6, marginBottom: 6 }}>
        {[46, 70, 58, 40].map((w, i) => (
          <Bar key={i} w={w} h={11} r={3} c="#e7e9ef" />
        ))}
      </div>
      {/* 그리드 행 */}
      {[0, 1, 2, 3].map((row) => (
        <div key={row} style={{ display: "flex", gap: 6, marginBottom: 5 }}>
          {[46, 70, 58, 40].map((w, i) => (
            <Bar key={i} w={w} h={8} r={3} c="#eef0f4" />
          ))}
        </div>
      ))}

      {/* '그리는 중' 느낌의 작은 배지 */}
      <span
        className="snd-float"
        style={{
          position: "absolute",
          right: -10,
          bottom: -10,
          width: 30,
          height: 30,
          borderRadius: "50%",
          background: C.blue,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 6px 16px rgba(0,0,255,0.28)",
          fontSize: 16,
          fontWeight: 700,
        }}
        aria-hidden
      >
        +
      </span>
    </div>
  );
}

function Bar({ w, h, r = 3, c = "#e2e4e9" }: { w: number; h: number; r?: number; c?: string }) {
  return <span style={{ display: "inline-block", width: w, height: h, borderRadius: r, background: c }} />;
}

